import { useState, useRef, useEffect } from 'react'
import classNames from 'classnames'

import style from './index.module.scss'

const Field = ({
  type,
  data,
  placeholder,
  onChange,
  classes = null,
  isDisabled = false,
  isRequired = false,
  min = null,
  max = null,
}) => {
  const inputRef = useRef(null)
  const [isFocused, setIsFocused] = useState(false)

  const onFocus = () => {
    inputRef.current.focus()
  }

  useEffect(() => {
    const input = inputRef.current

    if (input && input.value) {
      setIsFocused(true)
    }
  }, [])

  return (
    <div
      className={
        classNames(
          style.block,
          {
            [style.disabled]: isDisabled,
            [style.focused]: (isFocused || data || type === 'date'),
          },
          classes && classes.map(el => style[el] || el),
        )
      }
    >
      <input
        ref={inputRef}
        className={style.input}
        type={type}
        value={data}
        onChange={e => onChange(e.currentTarget.value)}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        required={isRequired}
        min={min}
        max={max}
        autoComplete={'on'}
      />
      <label className={style.label} onClick={onFocus}>
        {placeholder}
        {isRequired && <span>*</span>}
      </label>
    </div>
  )
}

export default Field
